export default "__VITE_ASSET__nHzdE29w__"